import {
  FormControl,
  HStack,
  TextInput,
  TextInputProps,
} from '@metservicedev/met-ui';
import React from 'react';
import { FieldPath, FieldValues, get, useFormContext } from 'react-hook-form';

import { InfoToolTip } from './InfoToolTip';
import { ValidationMessage } from './ValidationMessage';

type Props<T extends FieldValues> = {
  'data-testid'?: string;
  /** Fields that should be revalidated if this one changes */
  dependants?: FieldPath<T> | FieldPath<T>[];
  disabled?: boolean;
  fieldPath: FieldPath<T>;
  helperText?: string;
  label: string;
  tooltipContent?: string;
  textInputProps?: TextInputProps;
  formControlProps?: React.ComponentProps<typeof FormControl>;
};

export const FormTextInput = <T extends FieldValues>({
  'data-testid': testId,
  dependants,
  disabled,
  fieldPath,
  label,
  tooltipContent,
  textInputProps,
  formControlProps,
}: Props<T>): React.ReactElement<Props<T>> => {
  const { formState, register } = useFormContext<T>();
  const error = get(formState.errors, fieldPath);
  return (
    <FormControl
      {...formControlProps}
      disabled={disabled}
      invalid={!!error || undefined}
    >
      <HStack>
        <TextInput
          {...textInputProps}
          data-testid={testId}
          label={label}
          {...register(fieldPath, { deps: dependants })}
        />
        {tooltipContent && (
          <InfoToolTip
            tooltipContent={tooltipContent}
            data-testid={`${testId}-tooltip`}
          />
        )}
      </HStack>
      <ValidationMessage message={error?.message && String(error.message)} />
    </FormControl>
  );
};
